import { cn } from '../../lib/format.js';

export const Spinner = ({ className, label = 'Loading' }) => (
  <span role="status" aria-label={label} className={cn('inline-block', className)}>
    <svg viewBox="0 0 24 24" fill="none" className="size-full motion-safe:animate-spin">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.2" strokeWidth="2.5" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  </span>
);

export default Spinner;
